import React from "react";
import { Routes, Route } from "react-router-dom";

// Website Pages
import HomePage from "./HomePage";
import AboutPage from "./AboutPage";
import PricingPage from "./PricingPage";
import ContactPage from "./ContactPage";
import FAQsPage from "./FAQsPage";
import TermsPage from "./TermsPage";
import PrivacyPage from "./PrivacyPage";

const WebsiteRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/faqs" element={<FAQsPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
    </Routes>
  );
};

export default WebsiteRoutes;
